module.exports = __webpack_public_path__ + "static/media/NoResults.183d7b44.svg";